import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import logo from '@design-system/Assets/sella_green.png';
import profile from '@design-system/Assets/profile_icon.png';
import basket from '@design-system/Assets/basket_icon.png';
import nav_menu from '@design-system/Assets/nav_menu.png';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import SideModal from '@design-system/SideCart/SideModal';
import Mobile from './mobile';
import { useDispatch, useSelector } from 'react-redux';
import { getSellerId, getSellers } from '@app/sellers/redux/selectors';
import { get_partner_id, get_sellers } from '@app/sellers/redux/reducer';
import { getCart } from '@app/product/redux/selectors';
import { get_cart } from '@app/product/redux/reducer';
import { getLoggedInCart } from '@app/basket/redux/selectors';
import { get_logged_in_cart } from '@app/basket/redux/reducer';

const Main = styled.div`
  position: relative;
  top: 0;

  .nav {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 0px 40px;
    height: 100px;
    background: #fff;
  }

  aside {
    display: flex;
    gap: 29px;
    align-items: center;
  }

  .content {
    display: flex;
    gap: 14px;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
  }

  .menu {
    position: relative;
    display: inline-block;
  }

  .sub_menu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    margin-top: 10px;
    height: auto;
    overflow-y: scroll;
    overflow-x: hidden;
    border-radius: 5px;
    width: 100%;
  }

  .sub_menu_content {
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .link {
      text-decoration: none;
      color: #333333;
    }

    .logout {
      text-decoration: none;
      color: red;
    }
  }

  h4 {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    display: block;
    text-transform: capitalize;
  }

  .alert {
    position: absolute;
    z-index: 1;
    background: #d92d20;
    width: 15px;
    height: 15px;
    display: grid;
    place-items: center;
    font-size: 10px;
    font-weight: 600;
    border: 1px solid #fff;
    border-radius: 100%;
    color: #fff;
    margin-left: 12px;
    margin-top: -17px;
  }

  .icon {
    display: none;
  }

  .seller {
    display: flex;
    gap: 15px;
    align-items: center;

    img {
      width: 60px;
      height: 60px;
      border-radius: 100%;
      object-fit: cover;
    }

    .name {
      color: #333333;
      font-size: 24px;
      font-weight: 700;
    }
  }

  @media screen and (max-width: 992px) {
    aside {
      display: none;
    }

    .nav {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      padding-top: 47px;
      padding-bottom: 15px;
      height: 100px;
      background: #fff;
    }

    .seller {
      display: flex;
      gap: 15px;
      align-items: center;

      img {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        object-fit: cover;
      }

      .name {
        color: #333333;
        font-size: 18px;
        font-weight: 700;
      }
    }

    .icon {
      display: block;
      cursor: pointer;
      margin-top: 15px;
    }
  }
`;

const Navbar = ({ user }) => {
  const token = localStorage.getItem('x-access-token');
  const [open, setOpen] = useState(false);
  const seller = useSelector(getSellers);
  const dispatch = useDispatch();
  const cart = token ? useSelector(getLoggedInCart) : useSelector(getCart);
  const [show, setShow] = useState(false);
  const seller_id = useSelector(getSellerId);
  const seller_name = localStorage.getItem('seller_name');

  useEffect(() => {
    if (window.location.pathname === '/marketplace') {
      localStorage.removeItem('seller_name');
    }
  }, []);

  useEffect(() => {
    if (seller_name) {
      dispatch(get_partner_id(seller_name));
    }
  }, [dispatch, seller_name]);

  useEffect(() => {
    dispatch(get_cart(seller_id));
    dispatch(get_logged_in_cart(seller_id));
  }, [dispatch, seller_id]);

  useEffect(() => {
    if (seller_id) {
      dispatch(get_sellers(seller_id));
    }
  }, [dispatch, seller_id]);

  return (
    <Main>
      <div className="nav">
        {Object.keys(seller).length >= 1 ? (
          <div className="seller">
            {seller?.user?.photo_url && (
              <img src={seller?.user?.photo_url} alt={seller?.business_name} />
            )}
            <Link
              to={`/sella/${seller?.business_name}`}
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="name">{seller?.business_name}</div>
            </Link>
          </div>
        ) : (
          <Link
            to="/marketplace"
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            <img src={logo} alt="logo" />
          </Link>
        )}

        <SideModal isOpen={open} toggle={() => setOpen(!open)}>
          <Mobile
            user={user}
            toggle={() => setOpen(!open)}
            total={cart !== null ? cart?.length : 0}
          />
        </SideModal>
        {window.location.pathname !== '/marketplace' && (
          <img
            src={nav_menu}
            alt="nav_menu"
            className="icon"
            onClick={() => setOpen(!open)}
          />
        )}

        {window.location.pathname !== '/marketplace' && (
          <aside>
            {user.email_verified && token ? (
              <div className="menu">
                <div className="content" onClick={() => setShow(!show)}>
                  <img src={profile} alt="profile_icon" />
                  <h4>{user?.first_name}</h4>
                </div>
                <div className="sub_menu">
                  {show && (
                    <div className="sub_menu_content">
                      <Link to="/settings/profile" className="link">
                        Profile
                      </Link>

                      <Link to="/logout" className="logout">
                        Logout
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <Link to="/login" className="content">
                <img src={profile} alt="profile_icon" />
                <h4>Login</h4>
              </Link>
            )}

            <Link to="/basket" className="content">
              {cart?.length >= 1 && <div className="alert">{cart?.length}</div>}

              <img src={basket} alt="basket_icon" />
              <h4>Basket</h4>
            </Link>
          </aside>
        )}
      </div>
    </Main>
  );
};

export default Navbar;

Navbar.propTypes = {
  user: PropTypes.object.isRequired,
};
